import { SxProps, Theme } from "@mui/material";

/** Left inset matches activities table +/- column (pl before the remove button) */
export const selectedActivitiesListItemSx: SxProps<Theme> = {
  pl: 1.5,
  pr: 1,
  py: 0.75,
  alignItems: "flex-start",
  gap: 0.75,
};

/** Header spacer: same left inset as list item pl + 28px IconButton (matches table toggle column) */
export const selectedActivitiesToggleColumnSpacerSx: SxProps<Theme> = {
  width: (theme) => `calc(${theme.spacing(1.5)} + 28px)`,
  flexShrink: 0,
};

/** Matches table columns: Title, Category, Activity Types, Difficulty */
export const selectedActivityRowGridColumns = {
  xs: "1fr",
  md: "minmax(160px, 1.35fr) minmax(108px, 0.55fr) minmax(220px, 1.2fr) minmax(92px, 0.45fr)",
} as const;

export const selectedActivityRowGridSx: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  display: "grid",
  gridTemplateColumns: selectedActivityRowGridColumns,
  columnGap: 1.5,
  rowGap: 0.5,
  alignItems: "center",
  cursor: "grab",
  "&:active": { cursor: "grabbing" },
  /** Mui Chip sets its own cursor; match the drag handle on the rest of the row */
  "& .MuiChip-root": {
    cursor: "grab",
  },
  "& .MuiChip-root:active": {
    cursor: "grabbing",
  },
};

/** Match main activities table body cells (0.875rem / body2) */
export const selectedActivityRowTextSx: SxProps<Theme> = {
  fontSize: "0.875rem",
  lineHeight: 1.43,
  fontWeight: 400,
};

export const selectedActivitiesListHeaderRowSx: SxProps<Theme> = {
  display: "flex",
  gap: 0.75,
  mb: 0.5,
  pr: 1,
  alignItems: "stretch",
};

export const selectedActivitiesListHeaderGridSx: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  display: "grid",
  gridTemplateColumns: selectedActivityRowGridColumns,
  columnGap: 1.5,
  rowGap: 0.25,
};

export const selectedActivitiesListHeaderCellSx: SxProps<Theme> = {
  fontSize: "0.8125rem",
  fontWeight: 700,
  color: "text.secondary",
  letterSpacing: "0.02em",
  lineHeight: 1.43,
};

export const selectedActivitiesEmptyHintSx: SxProps<Theme> = {
  py: 0.75,
  fontSize: "0.875rem",
  lineHeight: 1.43,
};

export const selectedActivityCategoryCellSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
};

/** Lets pill clusters truncate inside grid columns */
export const selectedActivityPillColumnSx: SxProps<Theme> = {
  minWidth: 0,
};

export const selectedActivitiesListItemDragCloneSx: SxProps<Theme> = {
  ...selectedActivitiesListItemSx,
  bgcolor: "action.hover",
};

export const selectedActivityRowGridDraggingSx: SxProps<Theme> = {
  ...selectedActivityRowGridSx,
  cursor: "grabbing",
  "& .MuiChip-root": {
    cursor: "grabbing",
  },
  "& .MuiChip-root:active": {
    cursor: "grabbing",
  },
};
